<template>
  <div class="grid grid-cols-3 md:grid-cols-6 gap-4">
    <div v-for="image in images"
         class="relative pt-full border border-white rounded overflow-hidden cursor-pointer"
         :data-src="image.url"
         :data-lg-size="`${image.width}-${image.height}`"
         :data-sub-html="`<p><strong>${image.title}</strong><br>${image.caption}</p>`">
      <img :src="image.url"
           :alt="image.alt"
           class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
    </div>
  </div>
</template>

<script>
import lightGallery from 'lightgallery';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

export default {
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    lightGallery(this.$el, {
      plugins: [lgFullscreen, lgThumbnail, lgZoom],
      loop: false,
      download: false,
      zoomFromOrigin: true,
      fullScreen: true,
      thumbnail: true,
      toggleThumb: true,
      zoom: true,
      allowMediaOverlap: true,
    });
  },
};
</script>
